import { HOME_BY_LANG } from '../../lib/routes'

/**
 * Copy and paths shared by the blog index and the blog post pages.
 *
 * Every visible string is the site's existing copy, verbatim, except the
 * two added for the redesign (all three locales):
 *   - `rfq`        — the end-of-article quote nudge
 *   - `breadcrumb` — accessible name of the post breadcrumb (not visible)
 */
export const BLOG_I18N = Object.freeze({
    tr: {
        title: 'Blog & Haberler',
        subtitle: "Sektörel gelişmeler ve Ankaplastik'ten son haberler.",
        readMore: 'Devamını Oku',
        latestPosts: 'Son Yazılar',
        back: "Blog'a Dön",
        home: 'Ana Sayfa',
        sources: 'Kaynaklar',
        breadcrumb: 'Sayfa yolu',
        rfq: 'Projeniz için teklif isteyin',
    },
    en: {
        title: 'Blog & News',
        subtitle: 'Industry updates and latest news from Ankaplastik.',
        readMore: 'Read More',
        latestPosts: 'Latest Posts',
        back: 'Back to Blog',
        home: 'Home',
        sources: 'Sources',
        breadcrumb: 'Breadcrumb',
        rfq: 'Request a quote for your project',
    },
    de: {
        title: 'Blog & Aktuelles',
        subtitle: 'Branchenupdates und Neuigkeiten von Ankaplastik.',
        readMore: 'Weiterlesen',
        latestPosts: 'Neueste Beiträge',
        back: 'Zurück zum Blog',
        home: 'Startseite',
        sources: 'Quellen',
        breadcrumb: 'Seitenpfad',
        rfq: 'Angebot für Ihr Projekt anfordern',
    },
})

/**
 * The blog illustrations are exported at one size (public/blog/tech/*.png).
 * The attributes only reserve the box before load; CSS keeps `height: auto`,
 * so an image with another ratio still renders correctly once decoded.
 */
export const BLOG_IMAGE_SIZE = Object.freeze({ width: 1024, height: 301 })

/** @param {'tr'|'en'|'de'} lang */
export function blogCopy(lang) {
    return BLOG_I18N[lang] || BLOG_I18N.tr
}

/** @param {'tr'|'en'|'de'} lang */
export function blogIndexPath(lang) {
    return lang === 'tr' ? '/blog' : `/${lang}/blog`
}

/**
 * @param {'tr'|'en'|'de'} lang
 * @param {string} slug
 */
export function blogPostPath(lang, slug) {
    return `${blogIndexPath(lang)}/${slug}`
}

/** @param {'tr'|'en'|'de'} lang */
export function homePath(lang) {
    return HOME_BY_LANG[lang] || '/'
}

/** The locale home's RFQ section (#contact). @param {'tr'|'en'|'de'} lang */
export function homeContactHref(lang) {
    const home = homePath(lang)
    return home === '/' ? '/#contact' : `${home}#contact`
}
